import { TableItem } from 'components/atoms';
import { Table } from 'components/organisms';
import { useInfiniteTable } from 'hooks/useInfiniteTable';
import { useCustomParamId } from 'hooks/useParamId';
import { t } from 'i18next';
import { useGetContractTracks } from 'services/contract/products';

const ContractTracksTab = () => {
  const contractId = useCustomParamId('contractId');

  const tracks = useGetContractTracks(contractId);

  const tableProps = useInfiniteTable(tracks);

  return (
    <Table
      id='contract-tracks'
      //   size='compact'
      {...tableProps}
      data={{
        nodes: tableProps.data.nodes.map(p => ({
          ...p,
          id: `/track/${p.id}/contracts`,
        })),
      }}
      columns={[
        {
          label: t('input.label.title'),
          renderCell: ({ mainTitle }) => (
            <TableItem>
              <TableItem.Text text={mainTitle.title} />
            </TableItem>
          ),
        },
        {
          label: t('input.label.isrc'),
          renderCell: ({ isrc }) => (
            <TableItem>
              <TableItem.Text text={isrc} />
            </TableItem>
          ),
        },
        // {
        //   label: '',
        //   renderCell: ({ productType, id }) => (
        //     <TableItem justifyPosition='end'>
        //       <Button
        //         isClear
        //         onlyIcon
        //         onClick={() =>
        //           navigateToNewWindow(
        //             productType.id === PRODUCT_TYPE.Digital
        //               ? `music-product-digital/${id}/contracts`
        //               : productType.id === PRODUCT_TYPE.Physical
        //               ? `music-product-physical/${id}/contracts`
        //               : ''
        //           )
        //         }>
        //         <Button.Icon
        //           icon={<PiNavigationArrow transform='scale(-1,1)' />}
        //         />
        //       </Button>
        //     </TableItem>
        //   ),
        // },
      ]}
    />
  );
};

export default ContractTracksTab;
